import React from "react";
import { Stack, Text } from "@chakra-ui/react";

const BracketsList = ({ contents = [], offset = 0 }: { contents: string[]; offset?: number }) => {
  return (
    <Stack pos={"relative"} mt={2} gap={0}>
      {contents.map((content, index) => (
        <Text
          key={index}
          _before={{
            content: `"(${index + offset + 1})"`,
            display: "block",
            position: "absolute",
            left: "0",
          }}
          ml={8}
        >
          {content}
        </Text>
      ))}
    </Stack>
  );
};

export default BracketsList;
